import React from "react";

import { Box } from "@material-ui/core";

import { StyledGroupText } from "modules/Lesson/style";

import { MatrixTableBody, MatrixTableHeader } from "../../styles";

import { useStyles } from "../styles";

const DropDownTableResult = ({
	result,
	question: {
		data: { tableLabel, groups, answerOptionLabel }
	}
}) => {
	const classes = useStyles();

	const selectedAnswers = {};

	result?.selectedAnswers.forEach(
		({ questionAnswerOptionId, questionGroupId }) => (selectedAnswers[questionGroupId] = questionAnswerOptionId)
	);

	return (
		<>
			<MatrixTableHeader display="flex" maxWidth="595px" flexDirection="row">
				<Box display="flex" flexDirection="row" alignItems="center" width="100%">
					<Box
						display="flex"
						borderRight="solid 1px rgba(151, 151, 151, 0.3)"
						flexDirection="row"
						width="50%"
						height="100%"
						alignItems="center"
						pl="16px"
					>
						<StyledGroupText>{tableLabel}</StyledGroupText>
					</Box>

					<Box
						display="flex"
						borderRight="solid 1px rgba(151, 151, 151, 0.3)"
						flexDirection="row"
						width="50%"
						height="100%"
						alignItems="center"
						pl="16px"
					>
						<StyledGroupText>{answerOptionLabel}</StyledGroupText>
					</Box>
				</Box>
			</MatrixTableHeader>
			<MatrixTableBody isinresults>
				{groups?.map(({ text, id: gId, answerOptions }, gIndex) => (
					<Box
						key={gIndex}
						borderBottom={gIndex < groups.length - 1 ? "solid 1px rgba(151, 151, 151, 0.3)" : ""}
						display="flex"
						flexDirection="row"
						width="100%"
					>
						<Box display="flex" flexDirection="row" alignItems="center" width="100%">
							<Box
								display="flex"
								flexDirection="row"
								borderRight="solid 1px rgba(151, 151, 151, 0.3)"
								height="100%"
								width="50%"
								pl="16px"
								pt="13px"
							>
								<StyledGroupText>{text}</StyledGroupText>
							</Box>
							<Box display="flex" flexDirection="column" width="50%" padding={"10px 12px"} className={classes.gap5}>
								{answerOptions.map(({ id: optId, text, isCorrect }, _index) => {
									const correctAnswer = selectedAnswers[gId] === optId && isCorrect;
									const yourAnswer = selectedAnswers[gId] === optId;
									return (
										<Box
											className={`${
												correctAnswer
													? classes.correctBg
													: yourAnswer
													? classes.yourBg
													: isCorrect
													? classes.correctOptBg
													: ""
											} `}
											key={_index}
											display="flex"
											minHeight={"30px"}
											flexDirection="column"
											justifyContent={"center"}
											fontFamily="Open Sans"
											flexWrap="wrap"
										>
											{isCorrect && !yourAnswer ? (
												<span className={classes.correctOptText}>Unmarked correct answer</span>
											) : !correctAnswer && yourAnswer ? (
												<span className={classes.yourAnsText}>Incorrect answer</span>
											) : correctAnswer && yourAnswer ? (
												<span className={classes.correctAnsText}>Correct Answer</span>
											) : null}
											<span className={classes.optText}>{text}</span>
										</Box>
									);
								})}
							</Box>
						</Box>
					</Box>
				))}
			</MatrixTableBody>
		</>
	);
};

export default DropDownTableResult;
